import { Doughnut } from "react-chartjs-2";
import {
  green_chart_color,
  orange_chart_color,
  red_chart_color,
} from "../../lib/theme";
import { Typography } from "@mui/material";

export default function TextBubbleDoughnut(props: {
  yes: number;
  no: number;
  neu: number;
  title: string;
  width: number;
}) {
  const { yes, no, neu, title, width } = props;
  return (
    <div
      className="all-center-wrapper relative"
      style={{ width: `${width * 30}px`, height: `${width * 30}px` }}
    >
      <Doughnut
        options={{
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              xAlign: "right",
              yAlign: "top",
              caretSize: 0,
              caretPadding: 10,
            }
          },
          cutout: "80%",
        }}
        data={{
          labels: ["Dissatisfied", "Satisfied", "Neutral"],
          datasets: [
            {
              data: [no, yes, neu],
              backgroundColor: [
                red_chart_color,
                green_chart_color,
                orange_chart_color,
              ],
            },
          ],
        }}
      />
      <div
        className="all-center-wrapper column-wrapper"
        style={{ position: "absolute", width: "70%", textAlign: "center" }}
      >
        <Typography variant="h4" sx={{ fontSize: `${width * 3.5}px` }}>
          {title}
        </Typography>
      </div>
    </div>
  );
}
